import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import HalaIndiaMarkLogo from "./halaIndiaLogoMark";
import NonDisclouserAggrement from "./nonDisclouser";
import { useNavigate } from "react-router-dom";

// Main Tab Component
export default function NDAaggrementPrimary() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const limit = 1;
  const navigate = useNavigate();

  function MoveToNextTab() {
    if (activeTab >= limit) {
      navigate("/dashboard/home");
    } else {
      setActiveTab(activeTab + 1);
    }
  }

  function MoveToPreviousTab() {
    if (activeTab <= 0) {
      console.log("Reach the Limit of Below");
    } else {
      setActiveTab(activeTab - 1);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        maxHeight: "100%",
        overflowY: "auto",
        height: "100%",

        // bgcolor:"#EDF2F9",
        // Custom scrollbar styles
        "&::-webkit-scrollbar": {
          width: "6px", // Width of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Track color
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Thumb color
          borderRadius: "10px", // Optional rounded edges for the thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555", // Thumb color on hover
        },
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{
          borderBottom: 0,
          paddingBottom: 1,
          my: 2,
          px: 0.5,
          bgcolor: "white",
          width: "100%",
          borderColor: "divider",
          "& .MuiTab-root": { textTransform: "none", fontWeight: "500" },
        }}
      >
        <Tab
          label="Non Disclouser Aggrement"
          sx={{
            textTransform: "none",
            fontWeight: 500,
            mx: 1,
            borderRadius: "4px",
            border: activeTab === 0 ? "1px solid blue" : "divider",
            borderColor: activeTab === 0 ? "primary.main" : "divider",
            color: activeTab === 0 ? "primary.main" : "text.secondary",
            backgroundColor: activeTab === 0 ? "white" : "transparent",
            "&:hover": {
              backgroundColor: "action.hover",
            },
            padding: "6px 16px",
          }}
        />
        <Tab
          label="Hala standard logo mark aggrement"
          sx={{
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "4px",
            mx: 1,
            border: activeTab === 1 ? "1px solid blue" : "divider",
            borderColor: activeTab === 1 ? "primary.main" : "divider",
            color: activeTab === 1 ? "primary.main" : "text.secondary",
            backgroundColor: activeTab === 1 ? "white" : "transparent",
            "&:hover": {
              backgroundColor: "action.hover",
            },
            padding: "6px 16px",
          }}
        />
      </Tabs>

      {/* Content Area */}
      <Box
        mt={2}
        sx={{ boder: "2px solid green", width: "100%", height: "100%" }}
      >
        {activeTab === 0 && (
          <NonDisclouserAggrement
            MoveToPreviousTab={MoveToPreviousTab}
            MoveToNextTab={MoveToNextTab}
          />
        )}
        {activeTab === 1 && (
          <HalaIndiaMarkLogo
            MoveToPreviousTab={MoveToPreviousTab}
            MoveToNextTab={MoveToNextTab}
          />
        )}
      </Box>
    </Box>
  );
}
